import axios from 'axios';
import { BaseUrl } from '../Constant';
import Toaster from '../../Components/Toaster/Toaster';
const Toast = Toaster();
// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: BaseUrl, // Replace with your API base URL
  timeout: 10000, // Set a timeout if necessary
});

axiosInstance.interceptors.request.use(
  (config) => {
    // Retrieve each item from localStorage
    const toab_fair = localStorage.getItem('toab_fair');
    const toab_exibitor_token = localStorage.getItem('toab_exibitor_token');
    const toab_visitor_token = localStorage.getItem('toab_visitor_token');

    // Determine which token to use
    const token = toab_fair || toab_exibitor_token || toab_visitor_token;

    // If a token exists, set it in the Authorization header
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    // Return the modified config
    return config;
  },

  (error) => {
    console.error('Request Error:', error.message);
    return Promise.reject(error);
  }
);
// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // If the response is successful, just return it
    return response;
  },
  (error) => {
    // Handle errors globally
    if (error.response) {
      // Server responded with a status code outside 2xx
      const { status, data } = error.response;
      // Handle specific status codes
      switch (status) {
        case 422:
          Toast.fire({
            icon: 'error',
            title: `Your account hasn't been approved yet. Please contact our support team if you need further help.`,
          });
          break;
        case 401:
          const toab_fair = localStorage.getItem('toab_fair');
          const toab_exibitor_token = localStorage.getItem(
            'toab_exibitor_token'
          );
          const toab_visitor_token = localStorage.getItem('toab_visitor_token');

          if (toab_fair) {
            window.location.href = '/b2b-login';
            localStorage.removeItem('toab_fair');
          }
          if (toab_exibitor_token) {
            window.location.href = '/login';
            localStorage.removeItem('toab_exibitor_token');
          }
          if (toab_visitor_token) {
            window.location.href = '/visitor-login';
            localStorage.removeItem('toab_visitor_token');
          }

          // Optionally, redirect to login
          break;
        case 403:
          console.error('Forbidden:', data?.message || 'Access is denied.');
          break;
        case 404:
          console.error(
            'Not Found:',
            data?.message || 'Requested resource not found.'
          );
          break;
        case 500:
          console.error(
            'Server Error:',
            data?.message || 'Internal server error.'
          );
          break;
        default:
          console.error(
            'Error:',
            data?.message || 'An unknown error occurred.'
          );
      }
    } else if (error.request) {
      // Request was made, but no response was received
      console.error('No Response:', 'The server did not respond.');
    } else {
      // Something happened while setting up the request
      console.error('Error Setting Up Request:', error.message);
    }
    return Promise.reject(error);
  }
);
export type HTTPResponse<T> = {
  success: boolean;
  message?: string;
  token?: string;
  data: T;
};
// Example: Fetch a User
type RequestOptions<T> = {
  url: string;
  data?: T; // For `post`, `put`
  params?: Record<string, any>; // For query params
};
export const httpService = {
  get: async <T>({
    url,
    params,
  }: RequestOptions<null>): Promise<HTTPResponse<T>> => {
    const response = await axiosInstance.get<HTTPResponse<T>>(url, { params });
    return response.data;
  },

  post: async <T, U>({
    url,
    data,
  }: RequestOptions<U>): Promise<HTTPResponse<T>> => {
    const response = await axiosInstance.post<HTTPResponse<T>>(url, data);
    return response.data;
  },

  put: async <T, U>({
    url,
    data,
  }: RequestOptions<U>): Promise<HTTPResponse<T>> => {
    const response = await axiosInstance.put<HTTPResponse<T>>(url, data);
    return response.data;
  },
  patch: async <T, U>({
    url,
    data,
  }: RequestOptions<U>): Promise<HTTPResponse<T>> => {
    const response = await axiosInstance.patch<HTTPResponse<T>>(url, data);
    return response.data;
  },

  delete: async <T>({
    url,
    params,
  }: RequestOptions<null>): Promise<HTTPResponse<T>> => {
    const response = await axiosInstance.delete<HTTPResponse<T>>(url, {
      params,
    });
    return response.data;
  },
};

export default axiosInstance;
